<template>
  <div>
    <template v-if="isLoading">
      <template v-if="!isError">
        <loading :message="'データ読み込み中...'"></loading>
      </template>
    </template>
    <template v-else>
      <!-- 会社連絡 -->
      <div class="maininfo">

        <div class="tabs">
          <scroll-tabs style="width: 100%">
            <ul>
              <li :class="{ active: tab === TAB.INFO }"><a @click="tab = TAB.INFO">お知らせの詳細</a></li>

              <!-- <template v-if="isCreater"> -->
                <li :class="{ active: tab === TAB.CONF_READ }" v-if="isAuthor || authStore.isAdmin || authStore.hasPermission(PermissionConst.RENRAKU_CAN_ACCES_OTHER_READED)"><a @click="tab = TAB.CONF_READ">既読確認</a></li>
              <!-- </template> -->
            </ul>
          </scroll-tabs>
        </div><!-- /tabs -->

        <div class="tab-container">
          <tab-info v-if="tab === TAB.INFO" :info="renrakuDetail" :isLoding="isLoading"></tab-info>
          <tab-conf-read v-if="tab === TAB.CONF_READ && (isAuthor || authStore.isAdmin || authStore.hasPermission(PermissionConst.RENRAKU_CAN_ACCES_OTHER_READED))" :list="readList" :isLoding="isLoading"></tab-conf-read>
        </div>

      </div><!-- /maininfo -->
    </template>
    <div class="button-container">
      <p class="prev-page">
        <router-link :to="{
            name: RouterConst.RENRAKU_SEARCH,
          }">検索画面に戻る
        </router-link>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { dateFormat, timeFormat } from "@/filters/common";
import { useTab } from "@/composable/common/tab";
import { useRenrakuDetail } from '@/composable/renraku/detail/detail';
import Const from '@/const/Shinsei/Option';
import Info from '@/components/renraku/detail/parts/tabs/Info.vue'
import ConfRead from '@/components/renraku/detail/parts/tabs/ConfirmRead.vue'
import { useRouter } from "vue-router";
import { DialogService } from "@/service/DialogService";
import { RouterConst } from "@/const/Router";
import OptionConst from "@/const/Option";
import { useAuthStore } from "@/store/auth";
import { PermissionConst } from "@/const/Permission";

export default defineComponent({
  props: {
    oshiraseId: {
      type: Number,
      require: true,
    },
    dataType: {
      type: String,
      require: true,
    },
  },
  setup(props) {
    const TAB = {
      INFO: 'info',
      CONF_READ: 'conf_read',
    }

    const { isLoading, isError, getDetail, getReadList, renrakuDetail, readList } = useRenrakuDetail()
    const { tab } = useTab(TAB.INFO);
    const router = useRouter()
    const authStore = useAuthStore()
    const isAuthor = ref(false)

    onMounted(async () => {
      if (!props.oshiraseId) {
        DialogService.error({
          title: 'お知らせ情報の取得に失敗しました',
        }).then(v => {
          router.push({ name: RouterConst.RENRAKU_SEARCH })
        })
        return
      }

      await getDetail(props.oshiraseId)
      isAuthor.value = renrakuDetail.value?.created_by == authStore.user?.user_id;
      if(isAuthor || authStore.isAdmin){
        // 自身の作成したお知らせのみ既読確認できるようにする
        await getReadList(props.oshiraseId)
      }
    })

    return {
      dateFormat,
      timeFormat,
      isAuthor,
      Const,
      tab,
      TAB,
      isLoading,
      isError,
      renrakuDetail,
      readList,
      router,
      RouterConst,
      OptionConst,
      authStore,
      PermissionConst
    };
  },
  components: {
    'tab-info': Info,
    'tab-conf-read': ConfRead,
  },
});
</script>

<style lang="scss" scoped>
@import '@scss/components/renraku-detail.scss';
</style>
